import { createSelector } from 'reselect';
import { RecordOf } from 'immutable';
import { RootState } from 'store';

const selectDealershipSettingsState = () => (state: RecordOf<RootState>) => state.get('dealershipSettings');

export const selectDealershipSettings = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('settings'));

export const selectPaymentAccountLegalEntity = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('paymentAccountLegalEntity'));

export const selectLoading = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('loading'));

export const selectErrors = () => createSelector(selectDealershipSettingsState(), (substate) => substate.get('errors'));

export const selectNotifications = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('notifications'));

export const selectMailChimpCustomerUploadProgress = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('mailChimpCustomerUploadProgress'));

export const selectMailChimpAuthUrl = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('mailChimpAuthUrl'));

export const selectDealershipDepartments = () =>
  createSelector(selectDealershipSettingsState(), (substate) => substate.get('departments'));
